import { useParams } from "react-router-dom";

const ClientPage = () => {
  const { id } = useParams();
  return <div>Клиент: {id} </div>;
};

export default ClientPage;
